import React from "react";
import NvidiaGTCLogo from "./NvidiaGTCLogo";
import styled from "@emotion/styled";

const Navigation = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;

  .WhiteHeader {
    width: 100%;
    transition: all 0.5s;
    height: 44px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .BlackHeader {
    background-color: black;
    height: 60px;
    color: #fff;
  }

  .NavigationGTCContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: all 0.5s;
    width: 100%;
    padding-left: 15px;
    color: #000;
    leading-trim: both;
    text-edge: cap;
    font-family: NVIDIA Sans;
    font-size: 16px;
    font-style: normal;
    line-height: 30px;
    .NavigationGTCContent {
      display: none;
      position: relative;
      margin: 1em;
      overflow: hidden;
    }
    .NavigationGTCContent ul {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      list-style: none;
      padding: 0;
    }
    .NavigationGTCContent li {
      flex-basis: auto;
      text-align: center;
      background-color: #fff;
      text-wrap: nowrap;
    }
  }

  .WhiteHeaderContainer {
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
    padding: 0 60px;
    top: 0;
    transition: all 0.5s;
    width: 100%;
    height: 44px;
    margin: 0 auto;
    display: flex;
  }

  .gtc24-separator-hide-mobile,
  .gtc24-separator-hide-tablet {
    display: inline-block;
  }

  @media (max-width: 1280px) {
    .NavigationGTCContainer {
      font-size: 15px;
    }
    .WhiteHeaderContainer {
      max-width: 954px;
      padding: 0 0 0 30px;
    }
  }

  @media screen and (max-width: 1023px) {
    .NavigationGTCContainer {
      font-size: 11px;
      line-height: 14px;
      .NavigationGTCContent {
        max-width: 400px;
        ul {
          flex-wrap: wrap;
        }
      }
      .gtc24-separator-hide-tablet {
        display: none;
      }
    }
  }

  @media screen and (max-width: 640px) {
    .NavigationGTCContainer {
      padding-left: 5px;
      .NavigationGTCContent {
        margin: 0;
        li {
          flex-basis: auto;
          margin: 0;
          padding: 0 5px;
          text-align: center;
          background-color: #fff;
        }
      }
      .gtc24-separator-hide-mobile {
        display: none;
      }
    }
    .WhiteHeaderContainer {
      max-width: 380px;
    }
  }

  @media screen and (max-width: 330px) {
    .NavigationGTCContainer {
      font-size: 9px;
      line-height: 11px;
    }
  }
`;
const GTCNavigation = (props) => {
  return (
    <Navigation>
      <nav>
        <div className={"WhiteHeader"}>
          <div className={"WhiteHeaderContainer"}>
            <div className={"LogoContainer"}>
              <a href={"https://www.nvidia.com/gtc/"}>
                <NvidiaGTCLogo />
              </a>
            </div>
            <div className={"NavigationGTCContainer"}>
              <div className={"NavigationGTCContent"}>
                <ul>
                  <li>
                    <b>Workshops</b> March 17–21
                    <span className="gtc24-separator-hide-mobile"> | </span>
                  </li>
                  <li>
                    <b>AI Conference and Expo</b> March 18–21
                    <span className="gtc24-separator-hide-tablet"> | </span>
                  </li>
                  <li>
                    <b>Keynote</b> March 18
                    <span> | </span>
                    <b>San Jose, CA and Virtual</b>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className={"BlackHeader"}></div>
      </nav>
    </Navigation>
  );
};

export default GTCNavigation;
